import { render, staticRenderFns } from "./CarDamages.vue?vue&type=template&id=c2e807d2&scoped=true&"
import script from "./CarDamages.vue?vue&type=script&lang=js&"
export * from "./CarDamages.vue?vue&type=script&lang=js&"
import style0 from "./CarDamages.vue?vue&type=style&index=0&id=c2e807d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e807d2",
  null
  
)

export default component.exports